class PvLandingStickyHeader extends HTMLElement {
  #lastY = 0;
  #rafId = null;

  connectedCallback() {
    this.dataset.stickyState = 'inactive';
    this.#lastY = document.scrollingElement?.scrollTop ?? 0;
    document.addEventListener('scroll', this.#onScroll, { passive: true });
  }

  disconnectedCallback() {
    document.removeEventListener('scroll', this.#onScroll);
    if (this.#rafId !== null) cancelAnimationFrame(this.#rafId);
  }

  #onScroll = () => {
    if (this.#rafId !== null) return;
    this.#rafId = requestAnimationFrame(() => {
      this.#rafId = null;
      this.#update();
    });
  };

  #update() {
    const y = document.scrollingElement?.scrollTop ?? 0;
    const wrapper = this.parentElement;
    if (!wrapper) {
      this.#lastY = y;
      return;
    }

    const wrapperTop = wrapper.getBoundingClientRect().top;
    const isScrollingUp = y < this.#lastY;
    const isAtTop = wrapperTop >= 0;
    const isPastHeader = y > this.offsetHeight;
    this.#lastY = y;

    if (isAtTop) {
      this.dataset.stickyState = 'inactive';
      delete this.dataset.hasActivated;
      return;
    }
    if (!isPastHeader) return;

    if (isScrollingUp) {
      this.dataset.stickyState = 'active';
      this.dataset.hasActivated = 'true';
    } else {
      this.dataset.stickyState = 'idle';
    }
  }
}

if (!customElements.get('pv-landing-sticky-header')) {
  customElements.define('pv-landing-sticky-header', PvLandingStickyHeader);
}
